import { render } from "./BlueZonesTour.vue?vue&type=template&id=499b755b&scoped=true"
import script from "./BlueZonesTour.vue?vue&type=script&lang=js"
export * from "./BlueZonesTour.vue?vue&type=script&lang=js"

import "./BlueZonesTour.vue?vue&type=style&index=0&id=499b755b&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499b755b"]])

export default __exports__